<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Beneficial Owners holding significant beneficial interest</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/beneficial-owner"> -->
          <button (click)="addBeneficial()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/Ben3/edit?goveva=true&email=', 'method':'put', 'menu': 'Ben3'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
  
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
  
            <!-- <form> -->
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label>Name of the Beneficial Owner</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameOfOwner">
                </div>
              </div>
  
              <div class="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label>Date of entry in Register</label>
                <div class="input-group">
                  <input class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                    #a="ngbDatepicker" (click)="a.toggle();b.close();" [(ngModel)]="dateOfEntry">
                  <button class="input-group-addon" (click)="a.toggle();b.close();" type="button">
                    <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label>Date of filing of BEN-2 (SRN wise)
                </label>
                <div class="input-group">
                  <input class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                    #b="ngbDatepicker" (click)="b.toggle();a.close();" [(ngModel)]="dateOfFillingBen">
                  <button class="input-group-addon" (click)="b.toggle();a.close();" type="button">
                    <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
  
  
              <div class="col-md-4">
                <!-- <label>Date of cessation</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfCessation" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfCessation" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfCessation">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
  
              <div class="col-md-4">
                <!-- <label>Date of declaration under section 90 </label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateofdeclarationundersection90" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateofdeclarationundersection90" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateofdeclarationundersection90">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
  
            </div>
            <!-- </form> -->
  
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="ben3ListTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Name of the Beneficial Owner</th>
                    <th>Date of entry<br> in Register</th>
                    <th style="display: none">Date of entry in Register</th>
                    <th>Date of filing of<br> BEN-2 (SRN wise)</th>
                    <th style="display: none">Date of filing of BEN-2 (SRN wise)</th>
                    <th>Date of cessation</th>
                    <th style="display: none">Date of cessation</th>
                    <th>Date of declaration<br> under section 90 </th>
                    <th style="display: none">Date of declaration under section 90 </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                    <td>{{director.name}}</td>
                    <td>
                      <span style="display: none">{{director.dateOfEntry | date : "yMMdd"}}</span>
                      {{director.dateOfEntry | date : "dd-MM-y"}}</td>
                    <td style="display: none">{{director.dateOfEntry | date : "dd-MM-y"}}</td>
                    <td>
                      <span style="display: none">{{director.dateOfBEN2 | date : "yMMdd"}}</span>
                      {{director.dateOfBEN2 | date : "dd-MM-y"}}</td>
                    <td style="display: none">{{director.dateOfBEN2 | date : "dd-MM-y"}}</td>
  
                    <td>
                      <span style="display: none">{{director.dateOfCessation | date : "yMMdd"}}</span>
                      {{director.dateOfCessation | date : "dd-MM-y"}}</td>
                    <td style="display: none">{{director.dateOfCessation | date : "dd-MM-y"}}</td>
  
  
                    <td>
                      <span style="display: none">{{director.dateofdeclarationundersection90 | date : "yMMdd"}}</span>
                      {{director.dateofdeclarationundersection90 | date : "dd-MM-y"}}</td>
                    <td style="display: none">{{director.dateofdeclarationundersection90 | date : "dd-MM-y"}}</td>
                    <td>
                      <button type="button" (click)="editbeneficialOwnerdetail(director._id)" [appHasPermission]="{'Url': '/register/Ben3/edit?goveva=true&email=', 'method':'put', 'menu': 'Ben3'}"
                        class="btn-sm btn btn-warning">
                        <span class="fa fa-pencil"></span>
                      </button>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/Ben3/edit?goveva=true&email=', 'method':'put', 'menu': 'Ben3'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete BEN-3 details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletebeneficialOwnerdetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>